import { ADD_TOKEN, REMOVE_TOKEN } from "./types"

export const addToken = (token: string) => ({ type: ADD_TOKEN, token: token })

export const removeToken = () => ({ type: REMOVE_TOKEN })